<script lang="ts">
  import { T, useLoader } from '@threlte/core'
  import Wall from '../../assets/models/wall.stl'
  import MaxiprinterStl from '../maxiprinter-stl/MaxiprinterSTL.svelte'
  import { STLLoader } from 'three/examples/jsm/Addons.js'

  const wallModel = useLoader(STLLoader).load(Wall)
</script>

<T.AmbientLight color="#e0e0ff" intensity={0.4} />

<T.DirectionalLight
  castShadow
  color="#fffaf0"
  intensity={1.5}
  position={[15, 25, 15]}
  shadow.bias={-0.0005}
  shadow.camera.bottom={-10}
  shadow.camera.far={100}
  shadow.camera.left={-10}
  shadow.camera.near={0.5}
  shadow.camera.right={10}
  shadow.camera.top={10}
  shadow.mapSize.height={2048}
  shadow.mapSize.width={2048}
/>

<T.DirectionalLight color="#e6f0ff" intensity={0.8} position={[-10, 15, -10]} />

<T.DirectionalLight color="#fff5e6" intensity={0.7} position={[0, 10, -15]} />

<T.PointLight
  color="#ffffe0"
  distance={10}
  intensity={0.2}
  position={[0, -2, 0]}
/>

<T.PerspectiveCamera
  makeDefault
  oncreate={(ref) => {
    ref.lookAt(0, 0, 0)
  }}
  position={[0, 15, 17.5]}
  visible
/>

<T.Group>
  <MaxiprinterStl />
  <T.Mesh
    name="Platform"
    castShadow={true}
    receiveShadow
    rotation.x={-Math.PI / 2}
  >
    <T.CircleGeometry args={[7, 6000]} />
    <T.MeshStandardMaterial
      color="#ffd700"
      envMapIntensity={0.8}
      metalness={0.2}
    />
  </T.Mesh>
  <T.Mesh
    name="Platform"
    castShadow={true}
    position.y={0.001}
    receiveShadow
    rotation.x={-Math.PI / 2}
  >
    <T.CircleGeometry args={[2.5, 6000]} />
    <T.MeshStandardMaterial
      color="#ffffff"
      envMapIntensity={0.8}
      metalness={0.2}
      roughness={0.3}
    />
  </T.Mesh>
  {#if $wallModel}
    <T.Mesh
      name="Wall Front"
      castShadow
      receiveShadow
      rotation.x={-Math.PI / 2}
      scale={0.001}
    >
      <T is={$wallModel} />
      <T.MeshStandardMaterial
        color="#c6a072"
        displacementBias={0.01}
        displacementScale={0.02}
        flatShading={true}
        roughness={1}
      />
    </T.Mesh>
  {/if}
</T.Group>
